import React from "react";
import { useLocation } from "react-router-dom";
import { useUser } from "../../../Data/UserContext";
import { trackWatchLiveClicked } from "../../../utils/frontendTrackingEvents";
import { MATCH_CARD_COMPACT_WATCH_LIVE_HEADER_CLASS } from "../../Games/MatchCards/matchCardCompactUi";

type WatchLiveButtonProps = {
    fixtureId: string;
    ctaLocation: string;
    onClick: () => void;
    className?: string;
    /**
     * `responsive` (default): "WATCH" on small screens, "WATCH LIVE" from md up.
     * `full`: always "WATCH LIVE" (e.g. lobby cards with dedicated space).
     */
    label?: "responsive" | "full";
};

/** Pink WATCH / WATCH LIVE CTA — opens the stream player (not auto-mounted). */
export function WatchLiveButton({
    fixtureId,
    ctaLocation,
    onClick,
    className = MATCH_CARD_COMPACT_WATCH_LIVE_HEADER_CLASS,
    label = "responsive",
}: WatchLiveButtonProps) {
    const { user } = useUser();
    const location = useLocation();

    return (
        <button
            type="button"
            className={className}
            aria-label="Watch live"
            title="Watch live"
            onClick={(e) => {
                e.stopPropagation();
                trackWatchLiveClicked({
                    user_id: user?.userId,
                    cta_location: ctaLocation,
                    fixture_id: fixtureId,
                    pathname: location.pathname,
                });
                onClick();
            }}
        >
            {label === "full" ? (
                "WATCH LIVE"
            ) : (
                <>
                    <span className="md:hidden">WATCH</span>
                    <span className="hidden md:inline">WATCH LIVE</span>
                </>
            )}
        </button>
    );
}
